import CardComponent from 'core/card'
import { CardPaddings } from 'core/card/enum'
import NoRecords from 'core/no-records/no-records-container'
import React from 'react'
import { MappedWifiEvents } from '../../redux/types'
import Graphic from './Graphic'
import './index.scss'
import Title from './Title'

type WifiGraphicProps = {
  events: MappedWifiEvents
  minSignal: number | null
  maxSignal: number | null
  latestSignal: number | null
  score: number | null
}

export default function WifiGraphic({ minSignal, maxSignal, latestSignal, events, score }: WifiGraphicProps) {
  return (
    <div className="tile is-parent is-vertical has-padding-sm">
      <div className="tile is-child">
        <CardComponent isFullHeight padding={CardPaddings.MEDIUM}>
          <div>
            <Title minSignal={minSignal} maxSignal={maxSignal} latestSignal={latestSignal} score={score}/>
          </div>
          <div className="wifi-divider"/>
          {Object.keys(events).length ? <Graphic events={events}/> : <NoRecords  style={{ height: 'auto' }}/>}
        </CardComponent>
      </div>
    </div>
  )
}
